/**          Int         */
export const isHigherThan = (b: number) => (a: number) => a > b
export const isLowerThan = (b: number) => (a: number) => a < b
